import { notification } from 'antd';
const DEFAULT_DURATION = 3;

export const openNotification = (message, description, duration, color, isDestroy = false) => {
	if (!!isDestroy) notification.destroy();
	const args = {
		message: message,
		description: description,
		duration: duration === 0 ? 0 : duration || DEFAULT_DURATION, // 0 Keeping the notification until the user closes it
		style: {
			backgroundColor: color,
		},
	};
	notification.open(args);
};
